import AddGoal from './AddGoal'

export * from './AddGoal'

export default AddGoal
